import { Params, useParams } from "react-router-dom";
import TabsComp from "../../components/TabsComp";
import BrightnessComp from "./Brightness";
import AspectsComp from "./Aspects";
import StoredComp from "./Stored";
import useAllAssets from "../../hooks/useAllAssets";
import TreePMV from "./TreePMV";
import { useState } from "react";
import { TreeProps } from "antd";
import usePMV from "hooks/usePMV";
import CustomLayout from "components/Layout";

const MainPMV: React.FC = () => {
    const { encryptedId } = useParams<Params>();
    // Convierte encryptedId a un número y maneja casos donde sea undefined
    const assetId = encryptedId ? parseInt(encryptedId, 10) : 0;
    const hookAssets = useAllAssets({ pageSize: 1000 });
    const assetsPMV = hookAssets.data.filter(asset => asset.type_id === 20);
    const hookPMV = usePMV({ package_id: 17, pageSize: 10 });
    const [activeKey, setActiveKey] = useState("1");

    const [checkedKeys, setCheckedKeys] = useState<TreeProps['checkedKeys']>([assetId]);

    return (
        <CustomLayout>
            <div style={{ width: "100%", margin: "auto", padding: "20px", borderRadius: "8px" }}>
                <h2>PMV</h2>
                <TabsComp
                    defaultActiveKey={"1"}
                    activeKey={activeKey}
                    onChange={(key) => setActiveKey(key)}
                    items={[{
                        key: '1',
                        label: 'Aspectos',
                        children: <AspectsComp
                            assetId={assetId}
                            assetsPMV={assetsPMV}
                            checkedKeys={checkedKeys}
                            hookPMV={hookPMV}
                        />
                    }, {
                        key: "2",
                        label: "Brillo",
                        children: <BrightnessComp
                            checkedKeys={checkedKeys}
                            assetsPMV={assetsPMV}
                        />
                    }, {
                        key: "3",
                        label: `Base de datos (${hookPMV.totalItems})`,
                        children: <StoredComp
                            checkedKeys={checkedKeys}
                            assetsPMV={assetsPMV}
                            hookPMV={hookPMV}
                            setActiveKey={setActiveKey}
                        />
                    }, {
                        key: "4",
                        label: `Paneles (${Array.isArray(checkedKeys) ? checkedKeys.length : 1})`,
                        children: <TreePMV
                            assetsPMV={assetsPMV}
                            assetId={assetId}
                            checkedKeys={checkedKeys}
                            setCheckedKeys={setCheckedKeys}
                        />
                    }]}
                />
            </div>
        </CustomLayout>
    );
};

export default MainPMV;
